import { DatePicker } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const { RangePicker } = DatePicker;
const FinancialTrends = ({ formData, setFormData }) => {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [tab, setTab] = useState("comparison");

  const handleSelectChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      dateRange: value,
    }));
  };

  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] ">
      <div className="flex lg:items-center items:start lg:flex-row flex-col gap-y-4 justify-between">
        <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS ">
          Financial Trends
        </div>

        <div className="flex gap-2 mb-4">
          <RangePicker
            name="dateRange"
            value={formData?.dateRange}
            onChange={(value) => handleSelectChange(value)}
            className="input !h-[45px]"
          />
        </div>
      </div>

      <div className="bg-[#FFFBF2] py-[0.375rem]  rounded-[.5rem] flex lfitems-center mb-[.5rem]">
        <div className="flex flex-wrap gap-[1rem] lg:gap-[1.88rem] w-full lg:justify-start justify-center">
          {[
            { key: "disbursement", label: "Disbursement" },
            { key: "collection", label: "Collection" },
            { key: "comparison", label: "Comparison" },
          ].map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`text-[.9rem] font-[400] leading-4 min-w-[8.79188rem] py-[.5rem] px-[1.75rem] ${
                tab === key
                  ? "rounded-[0.375rem] bg-[#FFEEC3] shadow-sm flex items-center justify-center font-lexendS ndovu-gradient-title"
                  : "text-[#6B7280]"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={data?.financialTrends}
          margin={{ top: 25, right: 30, left: 10, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
         {/* <YAxis tickFormatter={(val) => `KSh ${(val / 1000).toFixed(1)}K`} /> */}
          <YAxis />
          <Tooltip formatter={(val) => `KSh ${val.toLocaleString()}`} />
          <Legend />

          {tab === "disbursement" && (
            <Line
              type="monotone"
              dataKey="disbursements"
              stroke="#FF5C5C"
              strokeWidth={3}
            />
          )}
          {tab === "collection" && (
            <Line
              type="monotone"
              dataKey="collections"
              stroke="#28a745"
              strokeWidth={3}
            />
          )}
          {tab === "comparison" && (
            <>
              <Line
                type="monotone"
                dataKey="collections"
                stroke="#28a745"
                strokeWidth={3}
              />
              <Line
                type="monotone"
                dataKey="disbursements"
                stroke="#FF5C5C"
                strokeWidth={3}
              />
            </>
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FinancialTrends;
